import OrganizationAdmins from '../components/templates';

export const OrganizationAdminsContainer = () => {
  return <OrganizationAdmins />;
};
